module.exports = require('events').EventEmitter;



// WEBPACK FOOTER //
// (webpack)/~/readable-stream/lib/internal/streams/stream-browser.js